import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment";
import { DatePicker } from "./momentDatePickerComponents.js";
import { __ } from "../utils/i18n.js";
const { RangePicker } = DatePicker;
/**
 * A `RangePicker` depending on antd with localized WordPress settings.
 */ const DateRangePicker = (props)=>{
    const localeData = moment.localeData();
    return /*#__PURE__*/ _jsx(RangePicker, {
        // Localized short date format (German `DD.MM.YYYY`, zero-padded)
        // instead of antd's ISO `YYYY-MM-DD` default; overridable via props.
        format: localeData.longDateFormat("L"),
        locale: {
            lang: {
                locale: moment.locale(),
                placeholder: __("Select date"),
                rangePlaceholder: [
                    __("Start date"),
                    __("End date")
                ],
                today: __("Today"),
                now: __("Now"),
                backToToday: __("Back to today"),
                ok: __("OK"),
                clear: __("Clear"),
                month: __("Month"),
                year: __("Year"),
                timeSelect: __("Select time"),
                dateSelect: __("Select date"),
                monthSelect: __("Choose a month"),
                yearSelect: __("Choose a year"),
                decadeSelect: __("Choose a decade"),
                yearFormat: "YYYY",
                dateFormat: localeData.longDateFormat("LL"),
                dayFormat: "D",
                dateTimeFormat: localeData.longDateFormat("LLL"),
                monthFormat: "MMMM",
                monthBeforeYear: true,
                previousMonth: __("Previous month (PageUp)"),
                nextMonth: __("Next month (PageDown)"),
                previousYear: __("Last year (Control + left)"),
                nextYear: __("Next year (Control + right)"),
                previousDecade: __("Last decade"),
                nextDecade: __("Next decade"),
                previousCentury: __("Last century"),
                nextCentury: __("Next century")
            },
            timePickerLocale: {
                placeholder: __("Select time")
            },
            dateFormat: localeData.longDateFormat("LL"),
            dateTimeFormat: localeData.longDateFormat("LLL"),
            weekFormat: "YYYY-wo",
            monthFormat: "YYYY-MM"
        },
        ...props
    });
};
export { DateRangePicker };
